import React from 'react'

export default function errorBlock(touched, error, warning) {
  return (
    touched &&
    ((error && <p className="help is-danger">{error}</p>) ||
      (warning && <p className="help is-warning">{warning}</p>))
  );
}